import React from 'react'
import OverlaySpinner from '../overlay/presentational/OverlaySpinner'
import OverlayText from '../overlay/presentational/OverlayText'

const LoadingText = ({error, onLoadData}) => (
    error  ? (
        <OverlayText
            titleTransId='data_has_error'
            text=""
            buttonTextTransId='data_load_againg'
            logoutTextTransId='route_logout'
            onClickButton={() => onLoadData()}
        />
    ) : (
        <OverlaySpinner 
            transId="data_is_loading"
        />
    )
)

export default LoadingText